
export const getSelectedText = () => window.getSelection().toString();


// WEBPACK FOOTER //
// ./src/modules/context-menu/context-menu-functions.js